export default "__VITE_ASSET__BuYgq5fw__"